<template>
  <div>
    <div class="show" v-if="payload">
      <header>
        <h2>{{ payload.title }}</h2>
      </header>
      <p>
        Poslední kontrola: <br />
        {{ payload.lastEvaluationDate }}
      </p>
      <div>
        <div v-if="payload.lastEvaluationResult === '1'">
          <img
            src="@/assets/vhodna.svg"
            width="20"
            height="20"
            alt="Voda vhodná ke koupání"
          />
          <p>Voda vhodná ke koupání</p>
        </div>
        <div v-else-if="payload.lastEvaluationResult === '2'">
          <img
            src="@/assets/nezavadna.svg"
            width="20"
            height="20"
            alt="Voda vhodná ke koupání s mírně zhoršenými vlastnostmi"
          />
          <p>Voda vhodná ke koupání s mírně zhoršenými vlastnostmi</p>
        </div>
        <div v-else-if="payload.lastEvaluationResult === '3'">
          <img
            src="@/assets/zhorsena.svg"
            width="20"
            height="20"
            alt="Zhoršená jakost vody"
          />
          <p>Zhoršená jakost vody</p>
        </div>
        <div v-else-if="payload.lastEvaluationResult === '4'">
          <img
            src="@/assets/nevhodna.svg"
            width="20"
            height="20"
            alt="Voda nevhodná ke koupání"
          />
          <p>Voda nevhodná ke koupání</p>
        </div>
        <div v-else-if="payload.lastEvaluationResult === '5'">
          <img
            src="@/assets/nebezpecna.svg"
            width="20"
            height="20"
            alt="Voda nebezpečná ke koupání - zákaz koupání"
          />
          <p>Voda nebezpečná ke koupání - zákaz koupání</p>
        </div>
      </div>
      <h3>Provozovatel</h3>
      <div>{{ payload.operatorTitle }}</div>
      <div v-if="payload.operatorCity">{{ payload.operatorCity }}</div>
      <div v-if="payload.operatorStreet">{{ payload.operatorStreet }}</div>
      <div v-if="payload.operatorZipCode">
        PSČ {{ payload.operatorZipCode }}
      </div>
      <div v-if="payload.operatorPhone">
        E-mail.: {{ payload.operatorPhone }}
      </div>
      <div v-if="payload.operatorEmail">Tel: {{ payload.operatorEmail }}</div>
      <div v-if="links.length > 0" class="gallery">
        <br />
        <div class="gallery-item show">
          <ImageSlider :images="links"></ImageSlider>
        </div>
        <br />
      </div>
      <h3>Kontroly kvality vod</h3>
      <div v-on:click="showModal" class="clickable">Zobrazit graf</div>
      <br />
      <table>
        <tbody>
          <tr
            v-for="evaluation in evaluations"
            v-bind:key="evaluation.OBJECTID"
          >
            <td>{{ evaluation.date }}</td>
            <td>
              <img
                v-if="evaluation.result === 1"
                src="@/assets/vhodna.svg"
                width="20"
                height="20"
                alt="Voda vhodná ke koupání"
                title="Voda vhodná ke koupání"
              />
              <img
                v-else-if="evaluation.result === 2"
                src="@/assets/nezavadna.svg"
                width="20"
                height="20"
                alt="Voda vhodná ke koupání s mírně zhoršenými vlastnostmi"
                title="Voda vhodná ke koupání s mírně zhoršenými vlastnostmi"
              />
              <img
                v-else-if="evaluation.result === 3"
                src="@/assets/zhorsena.svg"
                width="20"
                height="20"
                alt="Zhoršená jakost vody"
                title="Zhoršená jakost vody"
              />
              <img
                v-else-if="evaluation.result === 4"
                src="@/assets/nevhodna.svg"
                width="20"
                height="20"
                alt="Voda nevhodná ke koupání"
                title="Voda nevhodná ke koupání"
              />
              <img
                v-else-if="evaluation.result === 5"
                src="@/assets/nebezpecna.svg"
                width="20"
                height="20"
                alt="Voda nebezpečná ke koupání - zákaz koupání"
                title="Voda nebezpečná ke koupání - zákaz koupání"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal">
      <div slot="body">
        <v-subheader>Šířka osy X</v-subheader>
        <v-slider
          color="teal darken-1"
          v-model="chartXStep"
          :min="10"
          :max="100"
          :step="10"
          @change="updateChart"
        ></v-slider>
        <div class="chart-container-wrapper">
          <div class="chart-container">
            <canvas ref="qualityChart"></canvas>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import ImageSlider from "./../components/ImageSlider.vue";
import Modal from "./../components/Modal.vue";
import Chart from "chart.js";
import { threshold } from "./../util/helpers";
import { DETAIL_GRAPH_MID_WIDTH_PX } from "./../util/constants";

export default {
  name: "Detail",
  props: ["payload"],
  components: {
    ImageSlider,
    Modal
  },
  data() {
    return {
      id: this.$route.params.id,
      isModalVisible: false,
      dates: [],
      ratings: [],
      modalChart: null,
      links: [],
      evaluations: [],
      chartXStep: 50
    };
  },
  mounted() {
    this.$emit("caption", "Koupací voda");
    this.createChart();
    this.createArrays();
  },
  watch: {
    payload: function() {
      this.createArrays();
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    createChart() {
      this.modalChart = new Chart(this.$refs.qualityChart, {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "",
              data: []
            }
          ]
        }
      });
    },
    createArrays() {
      const evaluations = this.payload.evaluations;

      this.dates = [];
      this.ratings = [];
      this.evaluations = evaluations;
      this.links = [];

      for (let i = evaluations.length - 1; i >= 0; i--) {
        const evaluation = evaluations[i];
        this.dates.push(evaluation.date);
        this.ratings.push(evaluation.result);
      }

      this.updateChart();

      const attachments = this.payload.attachments;

      if (attachments) {
        this.links = attachments.map(a => a.url);
      }
    },
    updateChart() {
      this.modalChart.destroy();

      const chartWidth = threshold(
        this.dates.length * this.chartXStep,
        DETAIL_GRAPH_MID_WIDTH_PX
      );

      this.modalChart = new Chart(this.$refs.qualityChart, {
        type: "line",
        data: {
          labels: this.dates,
          datasets: [
            {
              label: "Kontroly kvality vod; 1 = nejlepší, 5 = nejhorší",
              data: this.ratings,
              fill: false,
              lineTension: 0.5
            }
          ]
        },
        options: {
          tooltips: {
            callbacks: {
              label: context => {
                return context.value;
              }
            }
          },
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                ticks: {
                  padding: 7
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  min: 1,
                  max: 5,
                  callback: function(value) {
                    // check for whole number
                    if (value % 1 === 0) {
                      return value;
                    }
                  }
                }
              }
            ]
          }
        }
      });

      // resize chart based on number of samples in X axis
      this.modalChart.canvas.parentNode.style.width = `${chartWidth}px`;
    }
  }
};
</script>

<style scoped>
.chart-container-wrapper {
  overflow-x: auto;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 60vh;
}

.v-subheader {
  height: auto;
  padding: 0;
}

.side {
  margin: 5px;
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
  height: 91%;
  overflow: auto;
}

.contributors {
  margin-top: 4em;
  padding: 1.5em;
  padding-bottom: 0;
}

.contributors img {
  display: block;
  width: 100%;
  margin-bottom: 1.5em;
}

td {
  padding-right: 15px;
}

.clickable {
  text-decoration: underline;
  cursor: pointer;
  color: black;
}
</style>
